import { render, staticRenderFns } from "./checkJoinMember.vue?vue&type=template&id=2008212e&scoped=true&"
import script from "./checkJoinMember.vue?vue&type=script&lang=js&"
export * from "./checkJoinMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008212e",
  null
  
)

export default component.exports